/**
 * SingleColumn Component
 *
 * Single column section that accepts multiple content items:
 * - HeadingBlock
 * - QuillText (Rich Text)
 * - ImageBlock
 * - ButtonLink
 *
 * Styling uses Bootstrap utility class props consistent with other sections.
 */
import React from "react";
import { filterClass } from "../../utils/class-utils";
import { getHorizontalContentAlign, getSectionBlockAlignClass } from "../utils/content-alignment";
import type { SingleColumnProps } from "../types";

export function SingleColumn(props: SingleColumnProps) {
  const {
    Content,
    paddingYClass = "py-section-md",
    bgClass = "no-class",
    columnWidthClass = "no-class",
    contentAlignClass = "align-items-start text-start",
  } = props;

  const inheritedContentAlign = getHorizontalContentAlign(contentAlignClass) ?? "start";

  const sectionClasses = [
    bgClass,
    filterClass(paddingYClass),
  ]
    .map(filterClass)
    .filter(Boolean)
    .join(" ");

  const containerClasses = [
  ]
    .filter(Boolean)
    .join(" ");

  /**
   * ===== CLASSES (frontend can edit here) =====
   */
  const classes = {
    section: ["section section-single-column", sectionClasses].filter(Boolean).join(" ").trim(),
    container: ["container-xl", containerClasses].filter(Boolean).join(" ").trim(),
    columnWidth: filterClass(columnWidthClass) || undefined,
    innerwrap: ["d-flex flex-column gap-4", getSectionBlockAlignClass(contentAlignClass)]
      .filter(Boolean)
      .join(" "),
    contentItem: "w-100 component-item",
  };

  return (
    <section className={classes.section || undefined}>
      <div className={classes.container || undefined}>
        <div className={classes.columnWidth}>
          <div className={classes.innerwrap}>
            {Content?.map((item, idx) => {
              const ItemType = item.type as React.ComponentType<any>;
              return (
                <div key={idx} className={classes.contentItem}>
                  <ItemType {...item.props} inheritedContentAlign={inheritedContentAlign} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SingleColumn;
